import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  DEFAULT_WIDTH,
  DEFAULT_HEIGHT,
  DEFAULT_HDF,
  cleanImageUrl,
  replaceHttpToRelativeProtocol,
  changeImageUrlSize,
} from '../../utils/ProductUtils'
import placeholder from '@/checkout-instore-legacy/assets/images/sku-placeholder.svg'

export default function SkuImage({
  alt,
  className,
  url,
  width,
  height,
  highDensityFactor,
  inlineProps,
}) {
  const [onErrorTriggered, setOnErrorTriggered] = useState(false)
  const realUrl = url
    ? changeImageUrlSize(
        cleanImageUrl(replaceHttpToRelativeProtocol(url)),
        width,
        height,
        highDensityFactor
      )
    : null

  if (!realUrl || onErrorTriggered) {
    return (
      <img
        data-testid={'sku-placeholder'}
        alt={alt}
        className={className}
        src={placeholder}
        width={width}
        {...inlineProps}
      />
    )
  }

  return (
    <img
      data-testid={'sku-image'}
      alt={alt}
      className={className}
      src={realUrl}
      width={width}
      onError={() => {
        setOnErrorTriggered(true)
      }}
      {...inlineProps}
    />
  )
}

SkuImage.defaultProps = {
  width: DEFAULT_WIDTH,
  height: DEFAULT_HEIGHT,
  highDensityFactor: DEFAULT_HDF,
  inlineProps: {},
  className: '',
}

SkuImage.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  highDensityFactor: PropTypes.number,
  inlineProps: PropTypes.object,
}
